import React from 'react'
import { Page } from 'admin-web-ui'

export const SudosTeaser: React.FC = () => (
  <Page>Error: SudoService is not installed.</Page>
)
